export abstract class SigningParams {
  static signFileTemplate = `<Naglowek xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="http://zsin.gugik.gov.pl/zawiadomienie/NaglowekZawiadomienia.xsd">
	<Metryka>
		<IdentyfikatorZmiany>{changeIdentifier}</IdentyfikatorZmiany>
		<NumerKolejny>{sequenceNumber}</NumerKolejny>
	</Metryka>
	<WykazPlikowZawiadomienia>{fileItems}
	</WykazPlikowZawiadomienia>
</Naglowek>`;

  static fileItemTemplate = `
		<PozycjaWykazuPlikow>
			<NazwaPliku>{fileName}</NazwaPliku>
			<SkrotPliku>{digestHex}</SkrotPliku>
			<RodzajPliku>{fileType}</RodzajPliku>
		</PozycjaWykazuPlikow>`;
}



// WEBPACK FOOTER //
// ./src/app/services/document-signing/signing-params.ts